import { createStore, combineReducers } from "redux";
import comReducer from "./reduce/comReducer";

const StoreBus = () => {
  return createStore(combineReducers(comReducer));
};

export default StoreBus;



// WEBPACK FOOTER //
// ./src/AntD/state/storeBus.js